export default __webpack_public_path__ + "static/media/greenThumbUp.00c8e880.svg";